<template>
  <ubi-page-container wide-main-content>
  <ubi-panel>
    <el-tabs type="border-card" v-model="activeName" @tab-click="handleClick" v-loading="getLoadingStats" :element-loading-text="$t('portals.list.chargementDonnees')">
<!--      FACEBOOK -->
      <el-tab-pane label="Facebook" name="Facebook">
         <BoxInfos :has-icon-info="true" :has-icon-close="false" title="INFORMATION">{{$t('statisticsMeta.infoNumberStats')}}</BoxInfos>
         <BasicTabs
             v-if="isFacebookTab && getStatistics.facebook"
             :tabActive="$route.params.tabActive || 'overview'"
             @tab-change="$emit('update:tabActive', $event)"
         >
          <template v-slot:overview>
            <div class="cards-wrapper">
              <div class="box-card-facebook">
                <h2>{{ $t('statisticsMeta.titleFacebook') }}</h2>
                <h3>{{ $t('statisticsMeta.discover')}}</h3>
                <StatisticItem
                    :attribute="getTitleLikesPageWithName"
                    filename="like.png"
                    :label="getTitleLikesPageWithName"
                    :value="(getStatistics.facebook && 'stats' in getStatistics.facebook)? getStatistics.facebook.page.fan_count : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.followersNumber')"
                    filename="follower.png"
                    :label="$t('statisticsMeta.followersNumber')"
                    :value="(getStatistics.facebook && 'stats' in getStatistics.facebook)? getStatistics.facebook.page.followers_count : 0"
                />
                <h3>{{ $t('statisticsMeta.interactions')}}</h3>
                <StatisticItem
                    :attribute="$t('statisticsMeta.pageDailyFollows')"
                    filename="check.png"
                    :label="$t('statisticsMeta.pageDailyFollows')"
                    :value="(getStatistics.facebook && 'stats' in getStatistics.facebook)? getStatistics.facebook.stats.page_daily_follows.value : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.pagePostEngagements')"
                    filename="nbPublication.png"
                    :label="$t('statisticsMeta.pagePostEngagements')"
                    :value="(getStatistics.facebook && 'stats' in getStatistics.facebook)? getStatistics.facebook.stats.page_post_engagements.value : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.pageTotalActions')"
                    filename="click.png"
                    :label="$t('statisticsMeta.pageTotalActions')"
                    :value="(getStatistics.facebook && 'stats' in getStatistics.facebook)? getStatistics.facebook.stats.page_total_actions.value : 0"
                />
              </div>
              <div class="box-card-facebook">
                <h2>
                  {{ $t('statisticsMeta.growingYourFacebookCommunity') }}
                </h2>
                <LineChart :chartData="getLineChartDataFacebook" :chartOptions="getLineChartOptions" v-if="(getStatistics && getStatistics.facebook)"/>
              </div>
            </div>
          </template>
          <template v-slot:publicationReport>
            <h3>{{ $t('statisticsMeta.postsFacebook') }}</h3>
            <div v-if="getPosts && getPosts.length > 0">
              <PaginationPage  :total="getPosts.length"
                               :currentPage.sync="currentPage"
                               :pageSize.sync="pageSize"
                               @update:currentPage="fetchPage"
                               @update:pageSize="fetchPageSize"/>
            </div>
            <div class="cards-wrapper">
              <div v-for="post in currentPosts" :key="post.id" class="cards">
                <PublicationCard
                    :image="post.full_picture"
                    :likes="post.stats && post.stats.post_reactions_like_total ? post.stats.post_reactions_like_total.value : 0"
                    :shares="post.stats && post.stats.shares ? post.stats.shares.value : 0"
                    :comments="post.stats && post.stats.post_activity_by_action_type ? post.stats && post.stats.post_activity_by_action_type.value : 0"
                    :publishedDate="post.created_time"
                    :description="post.message"
                />
              </div>
            </div>
            <div v-if="getPosts && getPosts.length > 0">
              <PaginationPage  :total="getPosts.length"
                               :currentPage.sync="currentPage"
                               :pageSize.sync="pageSize"
                               @update:currentPage="fetchPage"
                               @update:pageSize="fetchPageSize"/>
            </div>
          </template>
        </BasicTabs>
       <div v-else>
         <BoxInfos v-if="showBoxInfos && !getLoadingStats" @closeBoxInfos="closeBoxInfos" :has-icon-info="true" :has-icon-close="false">
           <p style="font-size: 18px;"><strong>{{$t('autoOpenDialog.title')}}</strong></p>
           <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialog.content')}}</p>
           <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialog.content1')}}</p>
           <p style="font-size: 18px;font-weight: lighter" class="mr-1" v-html="$t('autoOpenDialog.content2')"></p>
           <el-button type="primary" class="mb-3" @click="$router.push('/socialNetworks')">{{$t('autoOpenDialog.titleConfirmButton')}}</el-button>
         </BoxInfos>
       </div>
      </el-tab-pane>

<!--INSTAGRAM-->
      <el-tab-pane label="Instagram" name="Instagram">
        <BoxInfos :has-icon-info="true" :has-icon-close="false" title="INFORMATION">{{$t('statisticsMeta.infoNumberStats')}}</BoxInfos>
        <BasicTabs
            v-if="isInstagramTab && getStatistics.instagram"
            :tabActive="$route.params.tabActive || 'overview'"
            @tab-change="$emit('update:tabActive', $event)"
        >
          <template v-slot:overview>
            <div class="cards-wrapper">
              <div class="box-card-instagram">
                <h2>{{ $t('statisticsMeta.titleInsta') }}</h2>
                <h3>{{ $t('statisticsMeta.discover')}}</h3>
                <StatisticItem
                    :attribute="$t('statisticsMeta.followersNumber')"
                    filename="follower.png"
                    :label="$t('statisticsMeta.followersNumber')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.account.followers_count : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.numberPublication')"
                    filename="nbPublication.png"
                    :label="$t('statisticsMeta.numberPublication')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.account.media_count : 0"
                />
                <h3>{{ $t('statisticsMeta.interactions')}}</h3>
<!--                <StatisticItem-->
<!--                    :attribute="$t('statisticsMeta.allNumberViews')"-->
<!--                    filename="eye.png"-->
<!--                    :label="$t('statisticsMeta.allNumberViews')"-->
<!--                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.stats.impressions.value : 0"-->
<!--                />-->
                <StatisticItem
                    :attribute="$t('statisticsMeta.totalInteractions')"
                    filename="click.png"
                    :label="$t('statisticsMeta.totalInteractions')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.stats.total_interactions.value : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.reach')"
                    filename="eye.png"
                    :label="$t('statisticsMeta.reach')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.stats.reach.value : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.shares')"
                    filename="share.png"
                    :label="$t('statisticsMeta.shares')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.stats.shares.value : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.saves')"
                    filename="save.png"
                    :label="$t('statisticsMeta.saves')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.stats.saves.value : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.comments')"
                    filename="comment.png"
                    :label="$t('statisticsMeta.comments')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.stats.comments.value : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.likes')"
                    filename="like.png"
                    :label="$t('statisticsMeta.likes')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.stats.likes.value : 0"
                />
                <StatisticItem
                    :attribute="$t('statisticsMeta.accountsEngaged')"
                    filename="nbPerson.png"
                    :label="$t('statisticsMeta.accountsEngaged')"
                    :value="(getStatistics.instagram && 'stats' in getStatistics.instagram)? getStatistics.instagram.stats.accounts_engaged.value : 0"
                />
              </div>
              <div class="box-card-instagram">
                <h2>
                  {{ $t('statisticsMeta.growingYourInstagramCommunity') }}
                </h2>
                <LineChart :chartData="getLineChartDataInstagram" :chartOptions="getLineChartOptions" v-if="(getStatistics && getStatistics.instagram)"/>
              </div>
            </div>
          </template>
          <template v-slot:publicationReport>
            <h3>{{ $t('statisticsMeta.postsInsta') }}</h3>
            <div v-if="getPosts && getPosts.length > 0">
              <PaginationPage  :total="getPosts.length"
                               :currentPage.sync="currentPage"
                               :pageSize.sync="pageSize"
                               @update:currentPage="fetchPage"
                               @update:pageSize="fetchPageSize"/>
            </div>

            <div class="cards-wrapper">
              <div v-for="post in currentPosts" :key="post.id">
                <PublicationCard
                    :image="post.media_url"
                    :views="post.stats && post.stats.views ? post.stats.views : 0"
                    :likes="post.stats && post.stats.likes ? post.stats.likes.value : 0"
                    :shares="post.stats && post.stats.shares ? post.stats.shares.value : 0"
                    :comments="post.stats && post.stats.comments ? post.stats.comments.value : 0"
                    :saves="post.stats && post.stats.saves ? post.stats.saves.value : 0"
                    :publishedDate="post.timestamp"
                    :description="post.caption"
                />
              </div>
            </div>
            <div v-if="getPosts && getPosts.length > 0">
              <PaginationPage  :total="getPosts.length"
                               :currentPage.sync="currentPage"
                               :pageSize.sync="pageSize"
                               @update:currentPage="fetchPage"
                               @update:pageSize="fetchPageSize"/>
            </div>
          </template>
        </BasicTabs>
        <div v-else>
          <BoxInfos v-if="showBoxInfos && !getLoadingStats" @closeBoxInfos="closeBoxInfos" :has-icon-info="true" :has-icon-close="false">
            <p style="font-size: 18px;"><strong>{{$t('autoOpenDialog.title')}}</strong></p>
            <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialog.content')}}</p>
            <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialog.content1')}}</p>
            <p style="font-size: 18px;font-weight: lighter" class="mr-1" v-html="$t('autoOpenDialog.content2')"></p>
            <el-button type="primary" class="mb-3" @click="$router.push('/socialNetworks')">{{$t('autoOpenDialog.titleConfirmButton')}}</el-button>
          </BoxInfos>
        </div>
      </el-tab-pane>

<!--      LINKEDIN-->
      <el-tab-pane label="Linkedin" name="Linkedin">
        <statistics-linkedin :tabActive="$route.params.tabActive || 'overview'" @update:tabActive="updateTab"/>
      </el-tab-pane>
<!--      Google -->
      <el-tab-pane label="Google">
        <BoxInfos v-if="getIsDataGoogleReady" :has-icon-info="true" :has-icon-close="false" title="INFORMATION">{{$t('statisticsGoogle.infoNumberStats')}}</BoxInfos>
        <google-statistics v-if="getIsDataGoogleReady"/>
        <div v-else>
          <BoxInfos v-if="!getLoadingGoogle" @closeBoxInfos="closeBoxInfos" :has-icon-info="true" :has-icon-close="false">
            <p style="font-size: 18px;"><strong>{{$t('autoOpenDialogGoogle.title')}}</strong></p>
            <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialogGoogle.content')}}</p>
            <p style="font-size: 18px;font-weight: lighter" class="mr-1">{{$t('autoOpenDialogGoogle.content1')}}</p>
            <el-button type="primary" class="mb-3" @click="$router.push('/socialNetworks')">{{$t('autoOpenDialogGoogle.titleConfirmButton')}}</el-button>
          </BoxInfos>
        </div>
      </el-tab-pane>

    </el-tabs>
  </ubi-panel>
  <StatsOverview />
  </ubi-page-container>
</template>

<script>
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'
import { TabPane, Tabs } from 'element-ui'
import BasicTabs from '@/pages/statistics/statisticsMeta/components/BasicTabs.vue'
import StatisticItem from '@/pages/statistics/statisticsMeta/components/StatisticItem.vue'
import LineChart from '@/chart/LineChart.vue'
import PublicationCard from '@/pages/statistics/statisticsMeta/components/PublicationCard.vue'
import { $t } from '@/i18n'
import moment from 'moment'
import BoxInfos from '@/components/ui/BoxInfos.vue'
import PaginationPage from '@/components/ui/PaginationPage.vue'
import StatisticsLinkedin from '@/pages/statistics/statisticsLinkedin/StatisticsLinkedin.vue'
import { mapGetters } from 'vuex'
import GoogleStatistics from '@/pages/statistics/statisticsGoogle/GoogleStatistics.vue'
import StatsOverview from '@/pages/statistics/StatsOverview.vue'

export default {
  components: {
    GoogleStatistics,
    StatisticsLinkedin,
    PaginationPage,
    BoxInfos,
    LineChart,
    PublicationCard,
    // UbiSearchContainer,
    StatisticItem,
    BasicTabs,
    UbiPanel,
    UbiPageContainer,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    StatsOverview
  },
  data () {
    return {
      activeName: null,
      filtersDate: null,
      currentTab: null,
      pickerOptionsDateDebutInstagram: {
        disabledDate (time) {
          const today = new Date()
          const minDate = new Date(today.setDate(today.getDate() - 30)) // Retire 30 jours de la date actuelle
          return time.getTime() < minDate.getTime() || time.getTime() > Date.now() // Bloque les dates en dehors de cette plage
        },
        shortcuts: [{
          text: 'Aujourd\'hui',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Hier',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'Il y a une semaine',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }
        ]
      },
      pickerOptionsDateDebutFacebook: {
        disabledDate (time) {
          const today = new Date()
          const minDate = new Date(today.setDate(today.getDate() - 90)) // Retire 30 jours de la date actuelle
          return time.getTime() < minDate.getTime() || time.getTime() > Date.now() // Bloque les dates en dehors de cette plage
        },
        shortcuts: [{
          text: 'Aujourd\'hui',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Hier',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'Il y a une semaine',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }
        ]
      },
      pickerOptionsDateFin: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [{
          text: 'Aujourd\'hui',
          onClick (picker) {
            picker.$emit('pick', new Date())
          }
        }, {
          text: 'Hier',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            picker.$emit('pick', date)
          }
        }, {
          text: 'Il y a une semaine',
          onClick (picker) {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', date)
          }
        }
        ]
      },
      showBoxInfos: true,
      currentPage: 1,
      pageSize: 10
    }
  },
  computed: {
    ...mapGetters(['getUser', 'getSitimmoUser']),
    ...mapGetters('statisticsGoogle', ['getIsDataGoogleReady', 'getLoadingGoogle']),
    userRS () {
      return this.getUser.socialNetworkIds
    },
    login () {
      return this.getSitimmoUser.login
    },
    getStatistics () {
      return this.$store.getters['statisticsMeta/getStatistics']
    },
    getPosts () {
      if (this.$store.getters['statisticsMeta/callPosts']) {
        if (this.getStatistics.error) {
          this.$message({ message: 'Une erreur est survenue', type: 'error' })
        }

        let rawPosts = null

        if (this.isFacebookTab && this.getStatistics.facebook) {
          rawPosts = this.getStatistics.facebook.posts
        } else if (this.isInstagramTab && this.getStatistics.instagram) {
          rawPosts = this.getStatistics.instagram.posts
        }

        // #113305 : Si c'est un objet (et non null), on le transforme en tableau
        if (rawPosts && typeof rawPosts === 'object' && !Array.isArray(rawPosts)) {
          return Object.values(rawPosts)
        }

        return rawPosts || []
      }
      return []
    },
    localFilters () {
      return this.$store.getters['statisticsMeta/getFilters']
    },
    getLoadingStats () {
      return this.$store.getters['statisticsMeta/getLoadingStats']
    },
    getLineChartOptions () {
      return {
        responsive: true,
        lineTension: 1,
        scales: {
          y: {
            beginAtZero: true,
            padding: 25
          }
        }
      }
    },
    getLineChartDataFacebook () {
      if (this.currentTab === 'facebook' && this.getStatistics && this.getStatistics.facebook && this.getStatistics.facebook.stats) {
        const statisticGraph = this.getStatistics.facebook.stats.page_follows_by_day.values
        const allDates = statisticGraph.map((stat) => moment(stat.end_time).format('DD/MM/YYYY'))
        const valuesStats = statisticGraph.map((stat) => stat.value)
        return {
          labels: allDates,
          datasets: [
            {
              label: $t('statisticsMeta.followersNumber'),
              data: valuesStats,
              borderColor: '#00a4bd',
              borderWidth: 1
            }
          ]
        }
      } else {
        return {
          labels: [],
          datasets: []
        }
      }
    },
    getLineChartDataInstagram () {
      if (this.currentTab === 'instagram' && this.getStatistics && this.getStatistics.instagram && this.getStatistics.instagram.stats) {
        const statisticGraph = this.getStatistics.instagram.stats.follower_count.values
        const allDates = statisticGraph.map((stat) => moment(stat.end_time).format('DD/MM/YYYY'))
        const valuesStats = statisticGraph.map((stat) => stat.value)
        return {
          labels: allDates,
          datasets: [
            {
              label: $t('statisticsMeta.followersNumber'),
              data: valuesStats,
              borderColor: '#00a4bd',
              borderWidth: 1
            }
          ]
        }
      } else {
        return {
          labels: [],
          datasets: []
        }
      }
    },
    isFacebookTab () {
      return this.$store.getters['statisticsMeta/getCurrentDiffuseur'] === 'facebook'
    },
    isInstagramTab () {
      return this.$store.getters['statisticsMeta/getCurrentDiffuseur'] === 'instagram'
    },
    currentPosts () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      if (Array.isArray(this.getPosts)) {
        return this.getPosts.slice(start, end)
      }
      return []
    },
    getTitleLikesPageWithName () {
      return this.getSitimmoUser.nom
        ? this.$t('statisticsMeta.likedPage') + this.getSitimmoUser.nom
        : this.$t('statisticsMeta.likedPage')
    }
  },
  methods: {
    handleClick (tab) {
      this.$route.params.network = undefined
      this.$route.params.tabActive = undefined
      this.currentTab = tab.label.toLowerCase()
      switch (this.currentTab) {
        case 'facebook':
        case 'instagram':
          this.$store.commit('statisticsMeta/setDiffuseur', { diffuseur: this.currentTab })
          this.$store.dispatch('statisticsMeta/loadStatistics')
          break
        case 'linkedin':
          this.$store.dispatch('statisticsLinkedin/loadStatisticsLinkedin')
          break
        case 'google':
          this.$store.dispatch('statisticsGoogle/loadStatisticsGoogle')
          break
      }
      // Réinitialiser la page courante
      this.currentPage = 1
    },
    resetAllFilter () {
      this.$store.commit('statisticsMeta/setResetFilters', { tabName: this.currentTab })
      this.$store.dispatch('statisticsMeta/loadStatistics')
    },
    doFilter () {
      if (this.localFilters.dates) {
        this.$store.commit('statisticsMeta/setMode', 'dates')
      }
      this.$store.dispatch('statisticsMeta/loadStatistics')
    },
    closeBoxInfos (args) {
      if (args === 'close') {
        this.showBoxInfos = false
      }
    },
    fetchPage (page) {
      this.currentPage = page
    },
    fetchPageSize (size) {
      this.pageSize = size
      this.currentPage = 1
    },
    updateTab (tabName) {
      const wouldLikeToSeePosts = (tabName === 'publicationReport') ? 'posts' : null
      if (this.currentTab.toLowerCase() !== 'linkedin') {
        if (wouldLikeToSeePosts === 'posts') {
          this.$store.commit('statisticsMeta/setFilters', { key: 'type', value: wouldLikeToSeePosts })
        }
        this.$store.commit('statisticsMeta/setFilters', { key: 'type', value: null })
        this.$store.dispatch('statisticsMeta/loadStatistics')
      }
    }
  },
  mounted () {
    const networkOnParamsRoute = this.$route.params.network
    const tabActiveOnParamsRoute = this.$route.params.tabActive

    if (networkOnParamsRoute && tabActiveOnParamsRoute) {
      this.currentTab = networkOnParamsRoute.toLowerCase()
      this.$store.commit('statisticsMeta/setDiffuseur', { diffuseur: this.currentTab })
      this.activeName = networkOnParamsRoute
      const wouldLikeToSeePosts = (tabActiveOnParamsRoute === 'publicationReport') ? 'posts' : null
      if (this.networkName !== 'linkedin') {
        if (wouldLikeToSeePosts === 'posts') {
          this.$store.commit('statisticsMeta/setFilters', { key: 'type', value: wouldLikeToSeePosts })
        }
      }
    } else {
      this.activeName = 'Facebook'
      this.currentTab = this.activeName.toLowerCase()
      this.$store.commit('statisticsMeta/setDiffuseur', { diffuseur: 'facebook' })
    }
    this.$store.dispatch('statisticsMeta/loadStatistics')
  }
}
</script>

<style scoped>
h3 {
  color: #00a4bd;
  font-weight: 600;
  text-transform: Capitalize;
  font-size: 20px;
  margin-top: 20px;
}
.cards-wrapper {
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.box-card-facebook {
  margin: 5px;
  width: 45%;
  min-width: 430px;
  min-height: 310px;
  padding: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.box-card-instagram, .box-card-linkedin {
  margin: 5px;
  width: 45%;
  min-width: 430px;
  min-height: 500px;
  padding: 10px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.el-icon-question{
  font-size: 15px;
}
</style>
